<div style="padding: 5px 5px 5px 5px">
  <ng-container #outlet *ngIf="auth.isAuthenticated$ | async; else loggedOut">
    <button mat-raised-button color="accent" (click)="logOut()">{{ "Account.logout" | translate }}</button>
  </ng-container>

  <ng-template #loggedOut>
    <button mat-raised-button color="accent" (click)="logIn()" translate>{{ "Account.login" | translate }}</button>
  </ng-template>
</div>
